module.exports = __webpack_public_path__ + "static/media/wifi.dab38231.svg";